module.exports = __webpack_public_path__ + "static/media/bg1.02f46666.jpg";